module.exports = __webpack_public_path__ + "img/60_11.48e03cd0.png";